import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../css/styles.css";

const WhatsAppButton = () => {
  const phoneNumber = "254706136146";
  const message = encodeURIComponent(
    "Hello Nyatwende! I'd like to enquire about a safari."
  );

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="whatsapp-float-icon" />
      <span className="whatsapp-float-label">Chat with us</span>
    </a>
  );
};

export default WhatsAppButton;
